/* eslint-disable no-undef */
if (window.__assetCdnBase__) {
    __webpack_public_path__ = window.__assetCdnBase__;
} else if (process.env.NODE_ENV === 'production') {
    // In production, missing __assetCdnBase__ means every dynamic chunk silently
    // falls back to the bundle-relative publicPath. Flag it on window and surface
    // an Error so window.onerror handlers (and any subsequent unhandled-rejection
    // diagnostics) can attribute downstream chunk-load failures to this misconfig.
    window.__assetCdnBaseMissing__ = true;
    const msg = '[setupPublicPath] window.__assetCdnBase__ is not set; dynamic chunks will use the fallback publicPath.';
    console.error(msg);
    if (typeof reportError === 'function') {
        reportError(new Error(msg));
    } else {
        setTimeout(() => { throw new Error(msg); }, 0);
    }
}
